import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core'
import { JwtHelperService } from '@auth0/angular-jwt'
import { KeycloakBearerInterceptor } from './interceptors/keycloak-bearer-interceptor'


export function provideAbacus(): EnvironmentProviders {
  return makeEnvironmentProviders([
    JwtHelperService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true
    }
  ])
}
